module.exports = __webpack_public_path__ + "fonts/FormaDJRUI-Regular.a1f7470f.ttf";